<template>
  <div>
    <br />
    <v-btn-toggle background-color="white" borderless>
      <v-btn style="padding:15%;" x-large :height="height">
        {{ info[jsonTitle] }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
const props = {
  info: {
    default: [],
    type: Array,
  },
  jsonTitle: {
    default: "title",
    type: String,
  },
};

export default {
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 10;
        case "sm":
          return 10;
        case "md":
          return 10;
        case "lg":
          return 10;
        case "xl":
          return 10;
      }
    },
  },
  methods: {
    execute() {},
  },
  props: props,
};
</script>

<style scoped></style>
